export const getHubspotCookie = () =>
  document.cookie.replace(
    /(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  )
